import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import Button from "components/common/Button";
import { useNavigate } from "react-router-dom";
import "./TimesheetTab.scss";

function TimesheetNotActivated({ employeeId, onEnable }) {
  const navigate = useNavigate();

  const handleManageAll = () => {
    navigate("/main/settings?tab=clockin");
  };

  return (
    <Box className="timesheet-not-activated">
      <Box className="timesheet-not-activated-icon">
        <HistoryToggleOffIcon sx={{ fontSize: 30, color: "var(--color-text-body-primary, #7b7b7b)" }} />
      </Box>
      <p className="heading-h5-medium timesheet-not-activated-text">
        Clock In/Out is currently disabled for this employee.
      </p>
      <Box className="timesheet-not-activated-actions">
        <Button
          label="Enable clock in/out feature"
          variant="contained"
          color="primary"
          size="small"
          onClick={() => onEnable(employeeId)}
        />
        <Button
          label="Manage clock in/out feature for all employees"
          variant="text"
          color="primary"
          size="small"
          onClick={handleManageAll}
        />
      </Box>
    </Box>
  );
}

TimesheetNotActivated.propTypes = {
  employeeId: PropTypes.string.isRequired,
  onEnable: PropTypes.func.isRequired,
};

export default TimesheetNotActivated;
